import React, { useEffect, useRef } from "react";
import styled, { keyframes } from "styled-components";
import { useI18n } from "./i18n";
import { useTheme } from "./ThemeContext";

/* ══════════════════════════════════════════════════════════
   TRADUCTIONS
══════════════════════════════════════════════════════════ */
const TX = {
"hero.callout": {
    "fr": <>Dès l'inscription, <strong>100 EVP sont offerts et renouvelables</strong> en cas de perte</>,
    "en": <>Upon registration, <strong>100 EVP are offered and renewable</strong> in case of loss</>,
    "es": <>Al registrarse, <strong>se regalan 100 EVP y son renovables</strong> en caso de pérdida</>,
    "de": <>Bei der Registrierung <strong>werden 100 EVP geschenkt und sind erneuerbar</strong> im Falle eines Verlusts</>,
    "pt": <>No registo, <strong>são oferecidos 100 EVP e são renováveis</strong> em caso de perda</>,
    "ar": <>عند التسجيل، <strong>يتم منح 100 EVP مجاناً وقابلة للتجديد</strong> في حالة الخسارة</>
},
  /* Badge live */
  "hero.live1": {
    fr: "Marchés en direct ·",
    en: "Live markets ·",
    es: "Mercados en vivo ·",
    de: "Live-Märkte ·",
    pt: "Mercados ao vivo ·",
    ar: "أ ·  نشطة",
  },
    "hero.live2": {
    fr: "actifs",
    en: "active",
    es: "activos",
    de: "aktiv",
    pt: "ativos",
    ar: "أسواق مباشرة ن",
  },
  /* Titre ligne 1 */
"hero.t1": {
    "fr": "Tradez",
    "en": "Trade",
    "es": "Opera",
    "de": "Handeln",
    "pt": "Negocie",
    "ar": "تداول"
},
  /* Titre ligne 2 — mot vert */
"hero.t2g": {
    "fr": "avec des EVP.",
    "en": "with EVPs.",
    "es": "con EVPs.",
    "pt": "com EVPs.",
    "de": "mit EVPs.",
    "ar": "باستخدام EVP.",
},
  /* Titre ligne 2 — mot bleu */
"hero.t2b": {
    "fr": "Sans débourser",
    "en": "Without spending",
    "es": "Sin gastar",
    "de": "Ohne Ausgaben",
    "pt": "Sem gastar",
    "ar": "دون إنفاق"
  },
  /* Titre ligne 3 */
"hero.t3": {
    "fr": "un centime.",
    "en": "a single cent.",
    "es": "un solo céntimo.",
    "de": "einen einzigen Cent.",
    "pt": "um único cêntimo.",
    "ar": "سنت واحد."
  },
  /* Sous-titre */
"hero.sub": {
    "fr": "· Le Trading s'appuie exclusivement sur des points virtuels appelés EVP.",
    "en": "· Trading relies exclusively on virtual points called EVP.",
    "es": "· El trading se basa exclusivamente en puntos virtuales llamados EVP.",
    "de": "· Der Handel basiert ausschließlich auf virtuellen Punkten namens EVP.",
    "pt": "· O trading baseia-se exclusivamente em pontos virtuais chamados EVP.",
    "ar": "· يعتمد التداول حصريًا على نقاط افتراضية تسمى EVP."
},
"hero.sub1": {
    "fr": "· La plateforme est gratuite. Aucun dépôt d'argent réel ou de carte bancaire n'est requis ni accepté pour participer.",
    "en": "· The platform is free. No real money deposit or credit card is required or accepted to participate.",
    "es": "· La plataforma es gratuita. No se requiere ni se acepta ningún depósito de dinero real o tarjeta bancaria para participar.",
    "de": "· Die Plattform ist kostenlos. Es ist keine Einzahlung von echtem Geld oder einer Kreditkarte erforderlich oder akzeptiert, um teilzunehmen.",
    "pt": "· A plataforma é gratuita. Nenhum depósito em dinheiro real ou cartão de crédito é necessário ou aceito para participar.",
    "ar": "· المنصة مجانية. لا يُطلب ولا يُقبل أي إيداع لأموال حقيقية أو بطاقة مصرفية للمشاركة."
},
"hero.sub2": {
    "fr": "· Les utilisateurs misent leurs points EVP pour prendre position sur l'issue d'événements futurs.",
    "en": "· Users stake their EVP points to take a position on the outcome of future events.",
    "es": "· Los usuarios apuestan sus puntos EVP para tomar posición sobre el resultado de eventos futuros.",
    "de": "· Benutzer setzen ihre EVP-Punkte ein, um Positionen zum Ausgang zukünftiger Ereignisse einzugehen.",
    "pt": "· Os utilizadores apostam os seus pontos EVP para tomar posição sobre o resultado de eventos futuros.",
    "ar": "· يقوم المستخدمون بتمويل نقاط EVP الخاصة بهم لاتخاذ موقف بشأن نتائج الأحداث المستقبلية."
},
"hero.sub3": {
    "fr": "· Bien que l'activité repose sur de la simulation, sous certaines conditions d'éligibilité, 100 EVP de gain en plus = 1 $ USD de récompense.",
    "en": "· Although the activity is based on simulation, under certain eligibility conditions, 100 extra EVP profit = $1 USD reward.",
    "es": "· Aunque la actividad se basa en simulación, bajo ciertas condiciones de elegibilidad, 100 EVP de ganancia extra = 1 $ USD de recompensa.",
    "de": "· Obwohl die Aktivität auf Simulation basiert, entsprechen unter bestimmten Bedingungen 100 zusätzliche EVP Gewinn = 1 $ USD Belohnung.",
    "pt": "· Embora a atividade seja baseada em simulação, sob certas condições de elegibilidade, 100 EVP de lucro extra = 1 $ USD de recompensa.",
    "ar": "· على الرغم من أن النشاط يعتمد على المحاكاة، وتحت شروط أهلية معينة، فإن كل 100 EVP ربح إضافي = مكافأة قدرها 1 دولار أمريكي."
},
  /* CTA principal (non connecté) */
"hero.cta.signup_all": {
    "fr": "Commencer maintenant →",
    "en": "Start now →",
    "es": "Empezar ahora →",
    "de": "Jetzt starten →",
    "pt": "Começar agora →",
    "ar": "ابدأ الآن ←"
  },
    "hero.cta.signup":        { fr:"S'inscrire →",        en:"Sign up →",         es:"Registrarse →",     de:"Registrieren →",   pt:"Cadastrar →",       ar:"← إنشاء حساب"     },

  /* CTA principal (connecté) */
  "hero.cta.explore": {
    fr: "Explorer les marchés →",
    en: "Explore markets →",
    es: "Explorar mercados →",
    de: "Märkte erkunden →",
    pt: "Explorar mercados →",
    ar: "← استكشف الأسواق",
  },
  /* CTA secondaire */
  "hero.cta.login": {
    fr: "Se connecter",
    en: "Log in",
    es: "Iniciar sesión",
    de: "Anmelden",
    pt: "Entrar",
    ar: "تسجيل الدخول",
  },
  /* Flèche scroll */
  "hero.scroll": {
    fr: "Défiler",
    en: "Scroll",
    es: "Deslizar",
    de: "Scrollen",
    pt: "Rolar",
    ar: "تمرير",
  },
  /* Mention stores, sous les CTA */
  "hero.store.ios.eyebrow": {
    fr: "Télécharger sur",
    en: "Download on the",
    es: "Disponible en",
    de: "Laden im",
    pt: "Disponível na",
    ar: "حمّل من",
  },
  "hero.store.ios": {
    fr: "App Store",
    en: "App Store",
    es: "App Store",
    de: "App Store",
    pt: "App Store",
    ar: "App Store",
  },
  "hero.store.android.eyebrow": {
    fr: "Disponible sur",
    en: "Get it on",
    es: "Disponible en",
    de: "Jetzt bei",
    pt: "Disponível no",
    ar: "احصل عليه من",
  },
  "hero.store.android": {
    fr: "Google Play",
    en: "Google Play",
    es: "Google Play",
    de: "Google Play",
    pt: "Google Play",
    ar: "Google Play",
  },
  /* Stats labels */
  "stat.volume": {
    fr: "Volume total",
    en: "Total volume",
    es: "Volumen total",
    de: "Gesamtvolumen",
    pt: "Volume total",
    ar: "إجمالي الحجم",
  },
  "stat.open": {
    fr: "Marchés ouverts",
    en: "Open markets",
    es: "Mercados abiertos",
    de: "Offene Märkte",
    pt: "Mercados abertos",
    ar: "أسواق مفتوحة",
  },
  "stat.traders": {
    fr: "Traders actifs",
    en: "Active traders",
    es: "Traders activos",
    de: "Aktive Trader",
    pt: "Traders ativos",
    ar: "متداولون نشطون",
  },
  "stat.vol24": {
    fr: "Volume 24h",
    en: "24h volume",
    es: "Volumen 24h",
    de: "24h-Volumen",
    pt: "Volume 24h",
    ar: "حجم 24 ساعة",
  },
  /* Ticker labels */
  "ticker.l1": {
    fr: "Crypto · #1 volume",
    en: "Crypto · #1 volume",
    es: "Cripto · #1 volumen",
    de: "Krypto · #1 Volumen",
    pt: "Cripto · #1 volume",
    ar: "كريبتو · #1 حجم",
  },
  "ticker.t1": {
    fr: "BTC dépasse 100K$ avant fin 2026 ?",
    en: "BTC exceeds $100K before end of 2026?",
    es: "¿BTC supera los $100K antes de fin de 2026?",
    de: "BTC übersteigt 100K$ vor Ende 2026?",
    pt: "BTC ultrapassa $100K antes do fim de 2026?",
    ar: "هل يتجاوز BTC 100 ألف دولار قبل نهاية 2026؟",
  },
  "ticker.l2": {
    fr: "Sports · 🔥 Chaud",
    en: "Sports · 🔥 Hot",
    es: "Deportes · 🔥 Caliente",
    de: "Sport · 🔥 Heiß",
    pt: "Esportes · 🔥 Quente",
    ar: "رياضة · 🔥 رائج",
  },
  "ticker.t2": {
    fr: "Real Madrid gagne la CL 2026 ?",
    en: "Real Madrid wins CL 2026?",
    es: "¿Real Madrid gana la LC 2026?",
    de: "Real Madrid gewinnt die CL 2026?",
    pt: "Real Madrid vence a LC 2026?",
    ar: "هل يفوز ريال مدريد بدوري أبطال أوروبا 2026؟",
  },
  "ticker.l3": {
    fr: "Finance · Nouveau",
    en: "Finance · New",
    es: "Finanzas · Nuevo",
    de: "Finanzen · Neu",
    pt: "Finanças · Novo",
    ar: "مالية · جديد",
  },
  "ticker.t3": {
    fr: "La Fed baisse les taux en Q1 ?",
    en: "Fed cuts rates in Q1?",
    es: "¿La Fed baja las tasas en Q1?",
    de: "Fed senkt Zinsen in Q1?",
    pt: "Fed corta taxas no Q1?",
    ar: "هل تخفض الفيدرالي الأسعار في الربع الأول؟",
  },
  "ticker.yes": {
    fr: "OUI",
    en: "YES",
    es: "SÍ",
    de: "JA",
    pt: "SIM",
    ar: "نعم",
  },
  "ticker.no": {
    fr: "NON", en: "NO", es: "NO", de: "NEIN", pt: "NÃO", ar: "لا",
  },

  /* ── Carrousel "marchés en direct" (nouveau) ─────────────────────────── */
  "round.live.badge": {
    fr: "LIVE", en: "LIVE", es: "EN VIVO", de: "LIVE", pt: "AO VIVO", ar: "مباشر",
  },
  "round.endsIn": {
    fr: "Clôture dans", en: "Closes in", es: "Cierra en",
    de: "Schließt in", pt: "Fecha em", ar: "يُغلق خلال",
  },
  "round.h":   { fr:"H",   en:"H",   es:"H",   de:"H",   pt:"H",   ar:"س" },
  "round.min": { fr:"MIN", en:"MIN", es:"MIN", de:"MIN", pt:"MIN", ar:"د" },
  "round.sec": { fr:"SEC", en:"SEC", es:"SEC", de:"SEC", pt:"SEC", ar:"ث" },
  "round.prev": { fr:"Marché précédent", en:"Previous market", es:"Mercado anterior", de:"Vorheriger Markt", pt:"Mercado anterior", ar:"السوق السابق" },
  "round.next": { fr:"Marché suivant",   en:"Next market",     es:"Mercado siguiente", de:"Nächster Markt",  pt:"Próximo mercado",  ar:"السوق التالي" },
  "round.goto": { fr:(n)=>`Aller au marché ${n}`, en:(n)=>`Go to market ${n}`, es:(n)=>`Ir al mercado ${n}`, de:(n)=>`Zu Markt ${n}`, pt:(n)=>`Ir para o mercado ${n}`, ar:(n)=>`الانتقال إلى السوق ${n}` },
};

function useT() {
  const { lang } = useI18n();
  const t = (k, arg) => {
    const v = TX[k];
    if (!v) return k;
    const val = v[lang] ?? v.fr ?? k;
    return typeof val === "function" ? val(arg) : val;
  };
  const isRtl = lang === "ar";
  return { t, lang, isRtl };
}

/* ══════════════════════════════════════════════════════════
   ANIMATIONS
══════════════════════════════════════════════════════════ */
const fadeIn    = keyframes`from{opacity:0}to{opacity:1}`;
const slideIn   = keyframes`from{opacity:0;transform:translateY(16px)}to{opacity:1;transform:translateY(0)}`;
const blink     = keyframes`0%,100%{opacity:1}50%{opacity:.2}`;
const bounceY   = keyframes`0%,100%{transform:translateY(0)}50%{transform:translateY(8px)}`;
const arrowFade = keyframes`0%{opacity:0;transform:translate(-50%,-8px)}100%{opacity:1;transform:translate(-50%,0)}`;

/* Révélation du titre, mot par mot */
const revealWord = keyframes`
  from { opacity:0; transform:translateY(16px); filter:blur(6px); }
  to   { opacity:1; transform:translateY(0);    filter:blur(0); }
`;

/* "Trade ping" au toucher — anneau qui s'étend */
const pingRing = keyframes`
  from { transform:scale(.2); opacity:.95; }
  to   { transform:scale(2.8); opacity:0; }
`;
/* "Trade ping" — étiquette de variation qui flotte et s'efface */
const pingLabel = keyframes`
  0%   { opacity:0; transform:translate(-50%,-35%) scale(.75); }
  18%  { opacity:1; transform:translate(-50%,-62%) scale(1); }
  100% { opacity:0; transform:translate(-50%,-115%) scale(1); }
`;

/* ── Carrousel "marchés en direct" — transition d'entrée par carte ───── */
const roundSlideIn = keyframes`from{opacity:0;transform:translateX(16px)}to{opacity:1;transform:translateX(0)}`;

/* ══════════════════════════════════════════════════════════
   STYLED COMPONENTS
══════════════════════════════════════════════════════════ */
const CanvasWrap = styled.div`
  position: relative;
  width: 100%;
  height: auto;                 /* grandit avec le contenu : plus de texte coupé */
  min-height: 100vh;
  min-height: 100svh;           /* mobile : tient compte des barres du navigateur */
  background: ${({ theme }) => theme.name === "dark" ? "#04080f" : theme.bg};
  overflow: hidden;
  margin-bottom: 0;
    margin-top: -56px;

`;

const EVPCallout = styled.div`
  display:inline-flex;align-items:center;gap:.5rem;
  margin-top:.85rem;padding:.4rem .9rem;border-radius:100px;
  border:1px solid rgba(0,230,118,.25);background:rgba(0,230,118,.07);
  font-size:.72rem;color:${({theme})=>theme.textDim};
  strong{color:${({theme})=>theme.green};}
`;

/* Couche 1 — image ville futuriste de nuit (sombre uniquement) */
const BgImage = styled.div`
  position: absolute;
  inset: 0;
  background-image: url("https://images.unsplash.com/photo-1486325212027-8081e485255e?w=1600&q=80&auto=format&fit=crop");
  background-size: cover;
  background-position: center 55%;
 // opacity: ${({ $dark }) => $dark ? .99 : .99};
  filter: ${({ $dark }) => $dark ? "none" : "saturate(.7) brightness(1.3)"};
  animation: bgzoom 14s ease-out both;
  @keyframes bgzoom {
    from { transform: scale(1.10); }
    to   { transform: scale(1.03); }
  }
  @media(max-width:740px){
    background-position: 62% 55%;
    opacity: ${({ $dark }) => $dark ? .99 : .99};
  }
`;

/* Couche 2 — teinture : cyber en sombre, lavis doux en clair */
const BgTint = styled.div`
  position: absolute;
  inset: 0;
`;

/* Couche 3 — canvas animé */
const BgCanvas = styled.canvas`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  mix-blend-mode: ${({ $dark }) => $dark ? "screen" : "multiply"};
 // opacity: ${({ $dark }) => $dark ? .82 : .85};
`;

/* Gradient overlay texte — sombre vs clair */
const Overlay = styled.div`
  position: relative;           /* dans le flux : la hauteur du hero suit celle du texte */
  box-sizing: border-box;
  min-height: 100vh;
  min-height: 100svh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: ${({ $rtl }) => $rtl ? "flex-end" : "flex-start"};
  padding: 96px 7vw 96px;       /* 56px navbar (marge négative du hero) + air ; bas = barre de stats */
  text-align: ${({ $rtl }) => $rtl ? "right" : "left"};
  background: ${({ $rtl, $dark, theme }) => {
    if ($dark) {
      return $rtl
        ? "linear-gradient(270deg, rgba(4,8,18,.96) 0%, rgba(4,8,18,.88) 34%, rgba(4,8,18,.35) 62%, rgba(4,8,18,.03) 100%)"
        : "linear-gradient(90deg,  rgba(4,8,18,.96) 0%, rgba(4,8,18,.88) 34%, rgba(4,8,18,.35) 62%, rgba(4,8,18,.03) 100%)";
    }
    return $rtl
      ? `linear-gradient(270deg, ${theme.bg}f0 0%, ${theme.bg}d8 34%, ${theme.bg}55 62%, ${theme.bg}05 100%)`
      : `linear-gradient(90deg,  ${theme.bg}f0 0%, ${theme.bg}d8 34%, ${theme.bg}55 62%, ${theme.bg}05 100%)`;
  }};
  @media(max-width:740px){
    padding: 88px 6vw 104px;
    align-items: center;
    text-align: center;
    background: ${({ $dark, theme }) => $dark
      ? "linear-gradient(180deg, rgba(4,8,18,.82) 0%, rgba(4,8,18,.70) 50%, rgba(4,8,18,.88) 100%)"
      : `linear-gradient(180deg, ${theme.bg}d8 0%, ${theme.bg}b8 50%, ${theme.bg}e8 100%)`
    };
  }
`;

/* Orbs lumineux */
const Orb = styled.div`
  position:absolute;border-radius:50%;pointer-events:none;
  transform:translate3d(calc(var(--px,0) * 22px), calc(var(--py,0) * 22px), 0);
  transition:transform .05s linear;
`;
const Orb1 = styled(Orb)`
  width:500px;height:500px;right:-120px;top:-120px;
  background:${({theme}) => theme.name === "dark"
    ? "radial-gradient(circle,rgba(0,230,118,.07) 0%,transparent 70%)"
    : `radial-gradient(circle,${theme.green}14 0%,transparent 70%)`};
`;
const Orb2 = styled(Orb)`
  width:360px;height:360px;right:280px;bottom:-100px;
  transform:translate3d(calc(var(--px,0) * -16px), calc(var(--py,0) * -16px), 0);
  background:${({theme}) => theme.name === "dark"
    ? "radial-gradient(circle,rgba(79,195,247,.06) 0%,transparent 70%)"
    : `radial-gradient(circle,${theme.accent}12 0%,transparent 70%)`};
`;

const LiveBadge = styled.div`
  display:inline-flex;align-items:center;gap:6px;
  background:${({theme})=>theme.greenDim};border:1px solid ${({theme})=>theme.green}4d;
  border-radius:100px;padding:5px 14px;font-size:11px;color:${({theme})=>theme.green};
  letter-spacing:.08em;text-transform:uppercase;margin-bottom:18px;
  animation:${fadeIn} .6s ease both;
  span{
    letter-spacing:.08em;
    text-transform:uppercase;
  }
`;
const LiveDot = styled.span`
  width:6px;height:6px;border-radius:50%;background:${({theme})=>theme.green};
  display:inline-block;animation:${blink} 1.4s ease infinite;
`;

const HeroTitle = styled.h1`
  font-size:clamp(2rem,5.5vw,3rem);font-weight:800;
  line-height:1.06;letter-spacing:-0.04em;color:${({theme})=>theme.textNav};
  margin-bottom:14px;
  .g{color:${({theme})=>theme.green};}.b{color:${({theme})=>theme.accent};}
  @media(max-width:740px){ font-size:clamp(1.6rem,7vw,2.6rem); margin-bottom:10px; overflow-wrap:anywhere; }
`;

/* Un mot du titre, révélé individuellement (cascade contrôlée par --delay) */
const Word = styled.span`
  display:inline-block;
  opacity:0;
  animation:${revealWord} .6s cubic-bezier(.16,1,.3,1) both;
  animation-delay:var(--delay,0s);
  will-change:transform,opacity,filter;
`;

const HeroSub = styled.p`
  font-size:clamp(13px,1.5vw,16px);color:${({theme})=>theme.textDim};
  max-width:440px;line-height:1.68;margin-bottom:28px;
  animation:${slideIn} .9s cubic-bezier(.16,1,.3,1) both;
  @media(max-width:740px){ max-width:100%; font-size:12.5px; line-height:1.5; margin-bottom:10px; }
`;

const CtaRow = styled.div`
  display:flex;gap:12px;align-items:center;flex-wrap:wrap;
  animation:${fadeIn} 1.1s ease both;
  max-width:72%;
  @media(max-width:740px){max-width:100%; justify-content:center; margin-top:6px; }
`;

const CtaPrimary = styled.button`
  background:${({theme})=>theme.green};color:${({theme})=>theme.name==="dark"?"#050a06":"#ffffff"};border:none;border-radius:9px;
  padding:12px 26px;font-size:14px;font-weight:700;cursor:pointer;
  letter-spacing:.01em;transition:opacity .18s,box-shadow .18s;
  span{margin-right: .5rem}
  @media(max-width:740px){
    white-space:normal; line-height:1.4; padding:12px 18px; max-width:100%;
    span{display:block; margin:0 0 .2rem; font-size:13px;}
  }
  &:hover{opacity:.88;box-shadow:0 8px 24px ${({theme})=>theme.greenDim};}
  &:active{transform:translateY(0) !important;}
`;
const CtaSecondary = styled.button`
  background:${({theme})=>theme.fonNav};color:${({theme})=>theme.accent};
  border:1px solid ${({theme})=>theme.accent}59;border-radius:9px;
  padding:12px 22px;font-size:14px;cursor:pointer;
  transition:all .18s;letter-spacing:.01em;
  &:hover{border-color:${({theme})=>theme.accent};background:${({theme})=>theme.accent}14;}
`;

/* Mention stores — même habillage que StoreLink/StoreIcon/StoreTextCol du footer */
const StoreRow = styled.div`
  display:flex; gap:.6rem; margin-top:16px; flex-wrap:wrap;
  animation:${fadeIn} 1.3s ease both;
  @media(max-width:740px){ justify-content:center; margin-top:12px; }
`;
const StorePill = styled.a`
  display:flex; align-items:center; gap:.5rem;
  border-radius:9px; text-decoration:none;
  padding:.45rem .8rem;
  border:1px solid ${({theme})=>theme.name==="dark"?"rgba(255,255,255,.14)":theme.border};
  background:${({theme})=>theme.name==="dark"?"rgba(255,255,255,.04)":theme.bgCard};
  transition:all .15s;
  &:hover{border-color:${({theme})=>theme.name==="dark"?"rgba(255,255,255,.3)":theme.borderLight};background:${({theme})=>theme.name==="dark"?"rgba(255,255,255,.08)":theme.bgHover};transform:translateY(-2px);}
`;
const StoreIcon = styled.span`font-size:1.15rem;line-height:1;color:${({theme})=>theme.textNav};flex-shrink:0;`;
const StoreTextCol = styled.span`display:flex;flex-direction:column;line-height:1.15;`;
const StoreEyebrow = styled.span`font-size:.55rem;color:${({theme})=>theme.textMuted};letter-spacing:.02em;`;
const StoreName = styled.span`font-size:.78rem;font-weight:700;color:${({theme})=>theme.textNav};`;

const SparkSvg = styled.svg`width:100%;height:30px;margin-top:2px;overflow:visible;`;

/* ══════════════════════════════════════════════════════════
   CARROUSEL "MARCHÉS EN DIRECT" — remplace l'ancien TickerStack
   statique par une carte unique, animée, qui tourne automatiquement
   entre les marchés (flèches + pagination + pause au survol).
══════════════════════════════════════════════════════════ */
const RoundWrap = styled.div`
  position:absolute; right:5vw; top:50%; transform:translateY(-50%);
  width:300px; z-index:5; display:flex; flex-direction:column; gap:12px;
  @media(max-width:960px){ display:none; }
`;
const RoundCard = styled.div`
  position:relative; overflow:hidden;
  background:${({theme})=>theme.name==="dark"?"rgba(255,255,255,.05)":theme.bgCard};
  border:1px solid ${({theme})=>theme.name==="dark"?"rgba(255,255,255,.10)":theme.border};
  border-radius:16px; padding:16px 18px; backdrop-filter:blur(10px);
  box-shadow:0 16px 40px rgba(0,0,0,${({theme})=>theme.name==="dark"?".35":".08"});
  animation:${roundSlideIn} .5s cubic-bezier(.16,1,.3,1) both;
`;
const RoundHead = styled.div`display:flex; align-items:center; justify-content:space-between; margin-bottom:12px;`;
const RoundCoinRow = styled.div`display:flex; align-items:center; gap:8px; min-width:0;`;
const RoundCoin = styled.span`
  flex-shrink:0; width:26px; height:26px; border-radius:50%;
  display:flex; align-items:center; justify-content:center;
  font-size:.68rem; font-weight:900; color:#fff;
  background:${({$c1,$c2})=>`linear-gradient(135deg,${$c1},${$c2})`};
  box-shadow:0 3px 10px ${({$c1})=>$c1}55;
`;
const RoundLabel = styled.span`
  font-size:10px; color:${({theme})=>theme.textMuted}; letter-spacing:.05em;
  text-transform:uppercase; font-family:monospace; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;
`;
const RoundLivePill = styled.span`
  flex-shrink:0; display:inline-flex; align-items:center; gap:4px;
  background:rgba(255,82,82,.12); color:#ff5252; font-size:9px; font-weight:800;
  padding:3px 8px; border-radius:100px; letter-spacing:.04em;
`;
const RoundLiveDot = styled.span`width:5px;height:5px;border-radius:50%;background:#ff5252;display:inline-block;animation:${blink} 1.3s ease infinite;`;

const RoundTitle = styled.div`
  font-size:12px; color:${({theme})=>theme.textDim}; font-weight:500; line-height:1.35;
  margin-bottom:10px; display:-webkit-box; -webkit-line-clamp:2; -webkit-box-orient:vertical; overflow:hidden;
`;

const OutcomeRow = styled.div`display:flex; align-items:center; gap:8px; margin-top:8px;`;
const OutcomeSide = styled.div`display:flex; flex-direction:column; align-items:${({$right})=>$right?"flex-end":"flex-start"}; flex-shrink:0; width:38px;`;
const OutcomeLbl = styled.span`font-size:8px; color:${({theme})=>theme.textMuted}; letter-spacing:.04em;`;
const OutcomePct = styled.span`font-size:11px; font-weight:700; font-family:monospace; color:${({$color})=>$color};`;
const OutcomeTrack = styled.div`flex:1; height:5px; border-radius:100px; background:${({theme})=>theme.name==="dark"?"rgba(255,255,255,.08)":theme.border}; overflow:hidden;`;
const OutcomeFill = styled.div`
  height:100%; border-radius:100px; background:${({$color})=>$color};
  width:${({$pct})=>$pct}%; transition:width 1s cubic-bezier(.4,0,.2,1);
`;

const RoundFooter = styled.div`
  display:flex; align-items:center; justify-content:space-between; margin-top:12px;
  padding-top:11px; border-top:1px solid ${({theme})=>theme.name==="dark"?"rgba(255,255,255,.08)":theme.border};
`;
const RoundEndsLabel = styled.span`font-size:9px; color:${({theme})=>theme.textMuted}; text-transform:uppercase; letter-spacing:.03em;`;
const RoundCountdown = styled.div`display:flex; align-items:baseline; gap:2px; font-family:monospace; font-weight:800; font-size:13px; color:${({theme})=>theme.textNav};`;
const RoundCountdownSep = styled.span`opacity:.4; font-size:11px;`;

const RoundNavRow = styled.div`display:flex; align-items:center; justify-content:center; gap:10px;`;
const RoundArrowBtn = styled.button`
  width:28px; height:28px; border-radius:50%; flex-shrink:0;
  background:${({theme})=>theme.name==="dark"?"rgba(255,255,255,.06)":theme.bgCard};
  border:1px solid ${({theme})=>theme.name==="dark"?"rgba(255,255,255,.12)":theme.border};
  color:${({theme})=>theme.textDim}; display:flex; align-items:center; justify-content:center;
  cursor:pointer; font-size:14px; line-height:1; transition:all .15s;
  &:hover{ background:${({theme})=>theme.accent}; border-color:${({theme})=>theme.accent}; color:#fff; }
`;
const RoundDotsRow = styled.div`display:flex; align-items:center; gap:5px;`;
const RoundDotBtn = styled.button`
  height:6px; width:${({$active})=>$active?"18px":"6px"}; border-radius:100px; padding:0; border:none;
  cursor:pointer; background:${({$active,theme})=>$active?theme.accent:(theme.name==="dark"?"rgba(255,255,255,.16)":theme.border)};
  transition:width .3s cubic-bezier(.4,0,.2,1), background .2s;
`;

/* Stats strip — toujours visible y compris mobile */
const StatStrip = styled.div`
  position:absolute;bottom:0;left:0;right:0;
  display:flex;border-top:1px solid ${({theme})=>theme.name==="dark"?"rgba(255,255,255,.06)":theme.border};
  backdrop-filter:blur(8px);background:${({theme})=>theme.name==="dark"?"rgba(4,8,18,.40)":theme.bgCard+"a8"};
  pointer-events:none;
`;

const StatPartial = styled.sup`
  font-family:${({theme})=>theme.fontMono};font-size:.55rem;
  color:${({theme})=>theme.accent};font-weight:600;margin-left:.2rem;
  cursor:help;
`;

const StatItem = styled.div`
  flex:1;padding:10px 16px;
  text-align: center;
  border-right:1px solid ${({theme})=>theme.name==="dark"?"rgba(255,255,255,.05)":theme.border};
  display:flex;flex-direction:column;gap:2px;
  &:last-child{border-right:none;}
  @media(max-width:600px){ padding:8px 8px; }
`;
const StatVal = styled.div`
  font-family:monospace;font-size:14px;font-weight:600;
  color:${({$up,theme})=>$up?theme.green:theme.textNav};
  @media(max-width:600px){ font-size:11px; }
`;
const StatLbl = styled.div`
  font-size:9px;color:${({theme})=>theme.text};text-transform:uppercase;letter-spacing:.07em;
  @media(max-width:600px){ font-size:8px; letter-spacing:.04em; }
`;

/* Flèche scroll */
const ScrollArrow = styled.div`
  position:absolute;bottom:58px;left:50%;
  transform:translateX(-50%);
  display:flex;flex-direction:column;align-items:center;gap:6px;
  cursor:pointer;z-index:10;
  animation:${arrowFade} 1s 1.4s ease both;
  &:hover svg{opacity:.9;}
  /* Sur mobile / écrans bas : masquée, elle chevaucherait le texte */
  @media(max-width:740px), (max-height:700px){ display:none; }
`;
const ScrollLabel = styled.span`
  font-size:10px;color:${({theme})=>theme.textMuted};
  letter-spacing:.12em;text-transform:uppercase;font-family:monospace;
`;
const ArrowIcon = styled.svg`
  opacity:.55;
  animation:${bounceY} 1.8s ease-in-out infinite;
  transition:opacity .2s;
`;

/* "Trade ping" — anneau + variation flottante au tap/clic, ancré au point touché */
const PingRing = styled.span`
  position:absolute; left:0; top:0; width:26px; height:26px;
  margin:-13px 0 0 -13px; border-radius:50%; pointer-events:none;
  border:1.5px solid ${({$up,theme})=>$up ? theme.green : "#ff5252"};
  animation:${pingRing} .9s cubic-bezier(.2,.8,.3,1) both;
`;
const PingLabel = styled.span`
  position:absolute; left:0; top:0; pointer-events:none;
  font-family:${({theme})=>theme.fontMono || "monospace"};
  font-weight:700; font-size:13px; white-space:nowrap;
  color:${({$up,theme})=>$up ? theme.green : "#ff5252"};
  animation:${pingLabel} 1.1s ease both;
`;

/* ══════════════════════════════════════════════════════════
   SPARKLINE
══════════════════════════════════════════════════════════ */
function Sparkline({ data, color }) {
  const ref = useRef(null);
  useEffect(() => {
    const svg = ref.current;
    if (!svg) return;
    const w = svg.clientWidth || 170, h = 30;
    const mn = Math.min(...data), mx = Math.max(...data), rng = mx - mn || 1;
    const pts = data.map((v, i) =>
      `${(i / (data.length - 1)) * w},${h - ((v - mn) / rng) * (h - 4) - 2}`
    ).join(" ");
    const uid = color.replace("#", "");
    svg.innerHTML = `
      <defs><linearGradient id="sg${uid}" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stop-color="${color}" stop-opacity=".22"/>
        <stop offset="100%" stop-color="${color}" stop-opacity="0"/>
      </linearGradient></defs>
      <polygon points="${pts} ${w},${h} 0,${h}" fill="url(#sg${uid})"/>
      <polyline points="${pts}" fill="none" stroke="${color}" stroke-width="1.5"
        stroke-linecap="round" stroke-linejoin="round"/>`;
  }, [data, color]);
  return <SparkSvg ref={ref} />;
}

/* ══════════════════════════════════════════════════════════
   DONNÉES TICKERS (statiques, labels traduits en JSX)
══════════════════════════════════════════════════════════ */
const SPARK_DATA = [
  { sparkData:[62,65,70,68,72,71,73,72,74,72], color:"#00e676", initPct:72, lKey:"ticker.l1", tKey:"ticker.t1", letter:"₿", c1:"#F7931A", c2:"#FFD37A" },
  { sparkData:[40,38,35,33,36,34,35,33,34,34], color:"#ff5252", initPct:34, lKey:"ticker.l2", tKey:"ticker.t2", letter:"⚽", c1:"#2E7D32", c2:"#66BB6A" },
  { sparkData:[50,52,55,53,57,56,58,57,59,58], color:"#00e676", initPct:58, lKey:"ticker.l3", tKey:"ticker.t3", letter:"$",  c1:"#4361EE", c2:"#7B9CFF" },
];

/* ══════════════════════════════════════════════════════════
   MAIN COMPONENT
══════════════════════════════════════════════════════════ */
export default function HeroCanvas({ user, onNavigate, openAuthModal, stats, total, onLoginClick }) {
  const canvasRef = useRef(null);
  const wrapRef   = useRef(null);
  const { t, isRtl, lang } = useT();
  const { isDark } = useTheme();
  const [pcts, setPcts] = React.useState(SPARK_DATA.map(m => m.initPct));
  const [pings, setPings] = React.useState([]);
  const pointerRef = useRef({ x: 0.5, y: 0.5 });
  const reducedMotion = typeof window !== "undefined"
    && window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;

  /* ── Carrousel "marchés en direct" : index courant + décompte ────────── */
  const [roundIdx, setRoundIdx] = React.useState(0);
  const [roundSecs, setRoundSecs] = React.useState(() => 90 + Math.floor(Math.random() * 2500));
  const roundPausedRef = useRef(false);

  const goRound = (dir) => {
    setRoundIdx(i => (i + dir + SPARK_DATA.length) % SPARK_DATA.length);
    setRoundSecs(90 + Math.floor(Math.random() * 2500));
  };

  /* Avance automatique toutes les 6s, en pause au survol/focus de la carte */
  useEffect(() => {
    if (reducedMotion) return undefined;
    const id = setInterval(() => {
      if (!roundPausedRef.current) {
        setRoundIdx(i => (i + 1) % SPARK_DATA.length);
        setRoundSecs(90 + Math.floor(Math.random() * 2500));
      }
    }, 2500);
    return () => clearInterval(id);
  }, [reducedMotion]);

  /* Décompte "clôture dans" — purement indicatif, tourne en continu */
  useEffect(() => {
    if (reducedMotion) return undefined;
    const id = setInterval(() => {
      setRoundSecs(s => (s <= 0 ? 3600 : s - 1));
    }, 500);
    return () => clearInterval(id);
  }, [reducedMotion]);

  const fmtCountdown = (secs) => {
    const h = Math.floor(secs / 3600);
    const m = Math.floor((secs % 3600) / 60);
    const s = secs % 60;
    return { h: String(h).padStart(2, "0"), m: String(m).padStart(2, "0"), s: String(s).padStart(2, "0") };
  };

  /* ── Suivi pointeur/toucher (parallaxe + répulsion des particules) ── */
  useEffect(() => {
    const el = wrapRef.current;
    if (!el || reducedMotion) return undefined;
    const setFromClient = (clientX, clientY) => {
      const rect = el.getBoundingClientRect();
      pointerRef.current.x = Math.min(1, Math.max(0, (clientX - rect.left) / rect.width));
      pointerRef.current.y = Math.min(1, Math.max(0, (clientY - rect.top) / rect.height));
    };
    const onMove = (e) => setFromClient(e.clientX, e.clientY);
    const onTouchMove = (e) => {
      if (e.touches?.[0]) setFromClient(e.touches[0].clientX, e.touches[0].clientY);
    };
    el.addEventListener("pointermove", onMove);
    el.addEventListener("touchmove", onTouchMove, { passive: true });
    return () => {
      el.removeEventListener("pointermove", onMove);
      el.removeEventListener("touchmove", onTouchMove);
    };
  }, [reducedMotion]);

  /* ── Canvas animation ── */
  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    const resize = () => {
      canvas.width  = canvas.parentElement.offsetWidth;
      canvas.height = canvas.parentElement.offsetHeight;
    };
    resize();
    window.addEventListener("resize", resize);
    let ro;
    if (typeof ResizeObserver !== "undefined") {
      ro = new ResizeObserver(resize);
      ro.observe(canvas.parentElement);
    }

    const curves = [
      { color:"#00e676", alpha:.65, speed:.012, phase:0,   amp:28, base:.55 },
      { color:"#4fc3f7", alpha:.40, speed:.008, phase:1.2, amp:22, base:.38 },
      { color:"#ff5252", alpha:.28, speed:.015, phase:2.5, amp:18, base:.68 },
    ];
    const particles = Array.from({ length:70 }, () => ({
      x:Math.random()*1400, y:Math.random()*900,
      r:Math.random()*1.3+.3,
      vx:(Math.random()-.5)*.28, vy:(Math.random()-.5)*.14,
      alpha:Math.random()*.28+.04,
      color:["#00e676","#4fc3f7","#ffffff"][Math.floor(Math.random()*3)],
    }));

    let tick = 0, rafId;
    let smoothPX = 0, smoothPY = 0; // parallaxe lissée (lerp vers la position du pointeur)
    const gridColor = isDark ? "rgba(255,255,255,0.018)" : "rgba(0,0,0,0.05)";
    const textColor = isDark ? "rgba(255,255,255,0.07)" : "rgba(0,0,0,0.18)";
    const particleNeutral = isDark ? "#ffffff" : "#1565c0";
    particles.forEach(p => { if (p.color === "#ffffff") p.color = particleNeutral; });
    const draw = () => {
      const { width:w, height:h } = canvas;
      ctx.clearRect(0, 0, w, h);
      ctx.strokeStyle = gridColor; ctx.lineWidth = .5;
      for (let i=0;i<=12;i++){const x=(w/12)*i;ctx.beginPath();ctx.moveTo(x,0);ctx.lineTo(x,h);ctx.stroke();}
      for (let i=0;i<=7;i++){const y=(h/7)*i;ctx.beginPath();ctx.moveTo(0,y);ctx.lineTo(w,y);ctx.stroke();}
      ctx.fillStyle=textColor; ctx.font="9px monospace";
      [.25,.5,.75].forEach(p=>ctx.fillText(`${(p*100).toFixed(0)}%`,8,h*(1-p)-8));

      curves.forEach(c=>{
        const N=140; ctx.beginPath();
        for(let i=0;i<N;i++){
          const x=(w/(N-1))*i;
          const ry=Math.sin(i*.07+tick*c.speed*6+c.phase)*c.amp+Math.sin(i*.025+tick*c.speed*3+c.phase*.7)*c.amp*.5+h*(1-c.base);
          const y=Math.max(24,Math.min(h-54,ry));
          i===0?ctx.moveTo(x,y):ctx.lineTo(x,y);
        }
        ctx.strokeStyle=c.color; ctx.globalAlpha=c.alpha; ctx.lineWidth=1.8; ctx.stroke();
        if(c.base===.55){
          ctx.beginPath();
          for(let i=0;i<N;i++){
            const x=(w/(N-1))*i;
            const ry=Math.sin(i*.07+tick*c.speed*6+c.phase)*c.amp+Math.sin(i*.025+tick*c.speed*3+c.phase*.7)*c.amp*.5+h*(1-c.base);
            const y=Math.max(24,Math.min(h-54,ry));
            i===0?ctx.moveTo(x,y):ctx.lineTo(x,y);
          }
          ctx.lineTo(w,h);ctx.lineTo(0,h);ctx.closePath();
          const g=ctx.createLinearGradient(0,0,0,h);
          g.addColorStop(0,"rgba(0,230,118,.10)");g.addColorStop(1,"rgba(0,230,118,0)");
          ctx.fillStyle=g;ctx.globalAlpha=1;ctx.fill();
        }
        ctx.globalAlpha=1;
      });

      // Parallaxe légère des orbs, lissée vers la position du pointeur/doigt
      if (!reducedMotion) {
        const targetPX = pointerRef.current.x - 0.5;
        const targetPY = pointerRef.current.y - 0.5;
        smoothPX += (targetPX - smoothPX) * 0.06;
        smoothPY += (targetPY - smoothPY) * 0.06;
        if (wrapRef.current) {
          wrapRef.current.style.setProperty("--px", smoothPX.toFixed(4));
          wrapRef.current.style.setProperty("--py", smoothPY.toFixed(4));
        }
      }

      particles.forEach(p=>{
        // Répulsion : les particules s'écartent du doigt/curseur à proximité —
        // le champ "réagit" physiquement au toucher plutôt que de l'ignorer.
        if (!reducedMotion) {
          const px = pointerRef.current.x * w, py = pointerRef.current.y * h;
          const dx = p.x - px, dy = p.y - py;
          const dist = Math.sqrt(dx*dx + dy*dy);
          const R = 130;
          if (dist < R && dist > 0.001) {
            const force = (1 - dist / R) * 1.1;
            p.x += (dx / dist) * force;
            p.y += (dy / dist) * force;
          }
        }
        p.x+=p.vx;p.y+=p.vy;
        if(p.x<0)p.x=w;if(p.x>w)p.x=0;if(p.y<0)p.y=h;if(p.y>h)p.y=0;
        ctx.beginPath();ctx.arc(p.x,p.y,p.r,0,Math.PI*2);
        ctx.fillStyle=p.color;ctx.globalAlpha=p.alpha;ctx.fill();ctx.globalAlpha=1;
      });
      tick++; rafId=requestAnimationFrame(draw);
    };
    draw();
    return ()=>{window.removeEventListener("resize",resize);if(ro)ro.disconnect();cancelAnimationFrame(rafId);};
  }, [isDark, reducedMotion]);

  /* ── Ticker animation ── */
  useEffect(()=>{
    const id=setInterval(()=>{
      setPcts(prev=>prev.map(p=>Math.max(12,Math.min(92,p+(Math.random()-.5)*2.2))));
    },1800);
    return ()=>clearInterval(id);
  },[]);

  /* ── Scroll ── */
  const handleScrollDown = () => {
    const wrap = wrapRef.current;
    if (!wrap) return;
    const next = wrap.nextElementSibling;
    if (next) next.scrollIntoView({ behavior:"smooth" });
    else window.scrollTo({ top:window.innerHeight, behavior:"smooth" });
  };

  const handleCta = () => {
    if (user){ if(onNavigate) onNavigate("markets"); handleScrollDown()}
    else {
      onLoginClick("signup")
    }
  };
  const fmtVol = (v) => {
    if (v >= 1_000_000) return `${(v / 1_000_000).toFixed(1)}M`;
    if (v >= 1_000)     return `${(v / 1_000).toFixed(0)}K`;
    return v.toFixed(0);
  };
  const STATS = [
    { val:"+38.1%", lbl: t("stat.volume"), up:true  },
    { val:(stats.openCount),        lbl: t("stat.open"),   up:true  },
    { val:"+22.8%",     lbl: t("stat.traders"),up:false },
    { val:"+12.3%",    lbl: t("stat.vol24"),  up:true  },
  ];

    const STATS_ALL = [
    { val:(fmtVol(stats.totalVol)+" EVP"), lbl: t("stat.volume"), up:true  },
    { val:(stats.openCount),        lbl: t("stat.open"),   up:true  },
    { val:(fmtVol(total.total+424002)),     lbl: t("stat.traders"),up:false },
    { val:"+12.3%",    lbl: t("stat.vol24"),  up:true  },
  ];

  /* ── Titre découpé en mots pour la révélation en cascade ─────────────── */
  const titleTokens = React.useMemo(() => {
    const segments = [
      { text: t("hero.t1"),  cls: "" },
      { br: true },
      { text: t("hero.t2g"), cls: "g" },
      { text: t("hero.t2b"), cls: "b" },
      { br: true },
      { text: t("hero.t3"),  cls: "" },
    ];
    let i = 0;
    const tokens = [];
    segments.forEach((seg, si) => {
      if (seg.br) { tokens.push({ type: "br", key: `br-${si}` }); return; }
      seg.text.split(" ").filter(Boolean).forEach((word, wi) => {
        tokens.push({
          type: "word", key: `${si}-${wi}`, word, cls: seg.cls,
          delay: reducedMotion ? 0 : i * 0.055,
        });
        i++;
      });
    });
    return tokens;
  }, [lang, reducedMotion]); // eslint-disable-line react-hooks/exhaustive-deps

  /* ── Tap/clic : fait "trader" un tick de prix à l'endroit touché ─────── */
  const handleHeroTap = (e) => {
    if (e.target.closest("button, a, [role='button']")) return; // pas sur les CTA
    const rect = wrapRef.current.getBoundingClientRect();
    const point = e.touches?.[0] || e;
    const x = point.clientX - rect.left, y = point.clientY - rect.top;
    const delta = (Math.random() * 2.6 + 0.1).toFixed(1);
    const up = Math.random() > 0.32;
    const id = `${Date.now()}-${Math.random()}`;
    setPings(prev => [...prev.slice(-4), { id, x, y, delta, up }]);
    setTimeout(() => setPings(prev => prev.filter(p => p.id !== id)), 1150);
  };

  /* ── Effet "magnétique" du CTA principal : suit légèrement le curseur ── */
  const handleCtaMagnet = (e) => {
    const el = e.currentTarget;
    const rect = el.getBoundingClientRect();
    const mx = ((e.clientX - rect.left) / rect.width  - 0.5) * 10;
    const my = ((e.clientY - rect.top)  / rect.height - 0.5) * 10;
    el.style.transform = `translate(${mx}px, ${my - 3}px)`;
  };
  const resetCtaMagnet = (e) => { e.currentTarget.style.transform = ""; };

  return (
    <CanvasWrap
      ref={wrapRef}
      dir={isRtl ? "rtl" : "ltr"}
      onPointerDown={handleHeroTap}
    >
      {/* Couche 1 — image ville */}
      <BgImage $dark={isDark} />
      {/* Couche 2 — teinture cyber */}
      <BgTint $dark={isDark} />
      {/* Couche 3 — canvas animé */}
      <BgCanvas ref={canvasRef} $dark={isDark} />
      <Orb1 /><Orb2 />

      {/* Tap/clic n'importe où dans le hero → tick de prix flottant */}
      {pings.map(p => (
        <React.Fragment key={p.id}>
          <PingRing $up={p.up} style={{ left: p.x, top: p.y }} />
          <PingLabel $up={p.up} style={{ left: p.x, top: p.y }}>
            {p.up ? "+" : "−"}{p.delta}%
          </PingLabel>
        </React.Fragment>
      ))}

      {/* Contenu texte */}
      <Overlay $rtl={isRtl} $dark={isDark}>
      
        <LiveBadge><LiveDot /> {t("hero.live1")} <span>{stats.openCount}</span> {t("hero.live2")}</LiveBadge>

        <HeroTitle>
          {titleTokens.map(tok => tok.type === "br"
            ? <br key={tok.key} />
            : (
              <Word key={tok.key} className={tok.cls} style={{ "--delay": `${tok.delay}s` }}>
                {tok.word}&nbsp;
              </Word>
            )
          )}
        </HeroTitle>



        <HeroSub>{t("hero.sub")}</HeroSub>
<HeroSub>{t("hero.sub1")}</HeroSub><HeroSub>{t("hero.sub2")}</HeroSub><HeroSub>{t("hero.sub3")}</HeroSub>
        <CtaRow>
          <CtaPrimary onClick={handleCta} onMouseMove={handleCtaMagnet} onMouseLeave={resetCtaMagnet}>
            {!user && <span>🎁 {t("hero.callout")}.</span>}
                        <span>{user ? t("hero.cta.explore") : t("hero.cta.signup")}</span>

          </CtaPrimary>
          {!user && (
            <CtaSecondary onClick={()=>onLoginClick("login")}>
              {t("hero.cta.login")}
            </CtaSecondary>
          )}
        </CtaRow>

        {/* ⚠️ Remplacer par les vraies URLs une fois l'app publiée sur les stores */}
        <StoreRow>
          <StorePill href="https://apps.apple.com/app/id6811635856" target="_blank" rel="noopener noreferrer" aria-label={`${t("hero.store.ios.eyebrow")} ${t("hero.store.ios")}`}>
            <StoreIcon>🍎</StoreIcon>
            <StoreTextCol>
              <StoreEyebrow>{t("hero.store.ios.eyebrow")}</StoreEyebrow>
              <StoreName>{t("hero.store.ios")}</StoreName>
            </StoreTextCol>
          </StorePill>
          <StorePill href="https://play.google.com/store/apps/details?id=com.evenmt.app" target="_blank" rel="noopener noreferrer" aria-label={`${t("hero.store.android.eyebrow")} ${t("hero.store.android")}`}>
            <StoreIcon>▶</StoreIcon>
            <StoreTextCol>
              <StoreEyebrow>{t("hero.store.android.eyebrow")}</StoreEyebrow>
              <StoreName>{t("hero.store.android")}</StoreName>
            </StoreTextCol>
          </StorePill>
        </StoreRow>
        
      </Overlay>

      {/* Carrousel "marchés en direct" (desktop only) */}
      <RoundWrap
        onMouseEnter={() => { roundPausedRef.current = true; }}
        onMouseLeave={() => { roundPausedRef.current = false; }}
        onFocus={() => { roundPausedRef.current = true; }}
        onBlur={() => { roundPausedRef.current = false; }}
      >
        {(() => {
          const m = SPARK_DATA[roundIdx];
          const cd = fmtCountdown(roundSecs);
          const noPct = 100 - Math.round(pcts[roundIdx]);
          return (
            <RoundCard key={roundIdx}>
              <RoundHead>
                <RoundCoinRow>
                  <RoundCoin $c1={m.c1} $c2={m.c2}>{m.letter}</RoundCoin>
                  <RoundLabel>{t(m.lKey)}</RoundLabel>
                </RoundCoinRow>
                <RoundLivePill><RoundLiveDot />{t("round.live.badge")}</RoundLivePill>
              </RoundHead>

              <RoundTitle>{t(m.tKey)}</RoundTitle>

              <Sparkline data={m.sparkData} color={m.color} />

              <OutcomeRow>
                <OutcomeSide>
                  <OutcomeLbl>{t("ticker.yes")}</OutcomeLbl>
                  <OutcomePct $color={m.color}>{Math.round(pcts[roundIdx])}%</OutcomePct>
                </OutcomeSide>
                <OutcomeTrack>
                  <OutcomeFill $color={m.color} $pct={Math.round(pcts[roundIdx])} />
                </OutcomeTrack>
                <OutcomeSide $right>
                  <OutcomeLbl>{t("ticker.no")}</OutcomeLbl>
                  <OutcomePct $color={m.color === "#00e676" ? "#ff5252" : "#00e676"}>{noPct}%</OutcomePct>
                </OutcomeSide>
              </OutcomeRow>

              <RoundFooter>
                <RoundEndsLabel>{t("round.endsIn")}</RoundEndsLabel>
                <RoundCountdown>
                  {cd.h}<RoundCountdownSep>:</RoundCountdownSep>{cd.m}<RoundCountdownSep>:</RoundCountdownSep>{cd.s}
                </RoundCountdown>
              </RoundFooter>
            </RoundCard>
          );
        })()}

        <RoundNavRow>
          <RoundArrowBtn onClick={() => goRound(-1)} aria-label={t("round.prev")}>‹</RoundArrowBtn>
          <RoundDotsRow>
            {SPARK_DATA.map((_, i) => (
              <RoundDotBtn
                key={i}
                $active={i === roundIdx}
                onClick={() => { setRoundIdx(i); setRoundSecs(90 + Math.floor(Math.random() * 2500)); }}
                aria-label={t("round.goto", i + 1)}
              />
            ))}
          </RoundDotsRow>
          <RoundArrowBtn onClick={() => goRound(1)} aria-label={t("round.next")}>›</RoundArrowBtn>
        </RoundNavRow>
      </RoundWrap>

      {/* Stats strip — visible sur tous les écrans */}
      <StatStrip>
        {STATS.map((s,i)=>(
          <StatItem key={i}>
            <StatVal $up={s.up}>{s.val}{stats.isPartial && <StatPartial title={t("stat.partial")}>+</StatPartial>}</StatVal>
            <StatLbl>{s.lbl}</StatLbl>
            
          </StatItem>
        ))}
      </StatStrip>

      {/* Flèche scroll */}
      <ScrollArrow onClick={handleScrollDown} role="button" aria-label={t("hero.scroll")}>
        <ScrollLabel>{t("hero.scroll")}</ScrollLabel>
        <ArrowIcon width="28" height="28" viewBox="0 0 28 28" fill="none">
          <circle cx="14" cy="14" r="13" stroke={isDark ? "rgba(255,255,255,0.18)" : "rgba(0,0,0,0.15)"} strokeWidth="1"/>
          <polyline
            points="9 12 14 17 19 12"
            stroke={isDark ? "rgba(255,255,255,0.60)" : "rgba(0,0,0,0.55)"}
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </ArrowIcon>
      </ScrollArrow>
    </CanvasWrap>
  );
}
